import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import 'hammerjs';
import { SharedModule } from './core/modules/shared.module';
import { AppComponent } from './app.component';
import { FuseMainModule } from './main/main.module';
import { FuseSplashScreenService } from './core/services/splash-screen.service';
import { FuseConfigService } from './core/services/config.service';
import { FuseNavigationService } from './core/components/navigation/navigation.service';
import { FuseSampleModule } from './main/content/sample/sample.module';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from './core/services/auth.service';
import { AuthInterceptorService } from './core/services/auth-interceptor.service';
import { AuthGuard } from './core/services/auth-guard.service';
import { AppsModule } from './main/content/app/apps.module';
import { JwtHelper } from 'angular2-jwt';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { MAT_MOMENT_DATE_FORMATS, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr, 'fr');

const appRoutes: Routes = [
    /*{ path: '',  component: HomeCom },*/
    {
        path        : 'auth',
        loadChildren: './main/content/authentication/authentication.module#AuthenticationModule'
    },
    {
        path        : 'booking',
        loadChildren: './main/content/app/booking/booking.module#BookingModule'
    },
    {
        path        : 'analytics',
        loadChildren: './main/content/app/analytics/analytics.module#FuseAnalyticsDashboardModule'
    },
    {
        path        : 'chiffres',
        loadChildren: './main/content/app/chiffres/chiffres.module#FuseChiffresDashboardModule'
    },
    {
        path      : '**',
        redirectTo: 'calendar'
    }
];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports     : [
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes),
        SharedModule,
        TranslateModule.forRoot(),
        FuseMainModule,
        FuseSampleModule,
        AppsModule,
    ],
    providers   : [
        JwtHelper,
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true
        },
        AuthGuard,
        FuseSplashScreenService,
        FuseConfigService,
        FuseNavigationService,
        {provide: LOCALE_ID, useValue: 'fr' },
        // @see Datepicker with different locale: https://material.angular.io/components/datepicker/overview
        {provide: MAT_DATE_LOCALE, useValue: 'fr-FR'},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
        {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
    ],
    bootstrap   : [
        AppComponent
    ]
})
export class AppModule
{
}



// WEBPACK FOOTER //
// /usr/app/src/app/app.module.ts